var _a;
import { UnitSuffix } from '../../defs';
import { QUARTER_PIXEL_VALUE } from '../../internal/constants';
import { noConvert } from '../../internal/converters';
import { pixel } from '../../internal/converters/pixel';
var quarterToPixel = function (value) {
    return value * QUARTER_PIXEL_VALUE;
};
var quarterToCentimeter = function (value) {
    return pixel.cm(quarterToPixel(value));
};
var quarterToMillimeter = function (value) {
    return pixel.mm(quarterToPixel(value));
};
var quarterToInch = function (value) {
    return pixel.in(quarterToPixel(value));
};
var quarterToPica = function (value) {
    return pixel.pc(quarterToPixel(value));
};
var quarterToPoint = function (value) {
    return pixel.pt(quarterToPixel(value));
};
var quarterToREM = function (value, options) {
    return pixel.rem(quarterToPixel(value), options);
};
var quarterToEM = function (value, options) {
    return pixel.em(quarterToPixel(value), options);
};
var quarterToViewWidth = function (value, options) {
    return pixel.vw(quarterToPixel(value), options);
};
var quarterToViewHeight = function (value, options) {
    return pixel.vh(quarterToPixel(value), options);
};
var quarterToViewMin = function (value, options) {
    return pixel.vmin(quarterToPixel(value), options);
};
var quarterToViewMax = function (value, options) {
    return pixel.vmax(quarterToPixel(value), options);
};
export var quarter = (_a = {},
    _a[UnitSuffix.Pixel] = quarterToPixel,
    _a[UnitSuffix.Centimeter] = quarterToCentimeter,
    _a[UnitSuffix.Millimeter] = quarterToMillimeter,
    _a[UnitSuffix.Quarter] = noConvert,
    _a[UnitSuffix.Inch] = quarterToInch,
    _a[UnitSuffix.Pica] = quarterToPica,
    _a[UnitSuffix.Point] = quarterToPoint,
    _a[UnitSuffix.REM] = quarterToREM,
    _a[UnitSuffix.EM] = quarterToEM,
    _a[UnitSuffix.ViewWidth] = quarterToViewWidth,
    _a[UnitSuffix.ViewHeight] = quarterToViewHeight,
    _a[UnitSuffix.ViewMin] = quarterToViewMin,
    _a[UnitSuffix.ViewMax] = quarterToViewMax,
    _a);
//# sourceMappingURL=quarter.js.map